<template>
  <div class="choose_system">
    <p>Choose System:</p>
    <b-button variant="success" block @click="chooseSystem('crm')">CRM</b-button>
    <b-button variant="primary" block @click="chooseSystem('installation')">Installation</b-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    chooseSystem(system_name) {
      this.$emit('chooseSystem', system_name);
    }
  },
}
</script>

<style>

.choose_system {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
}

</style>